import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CantiereDetailPage from "@/pages/CantiereDetailPage";
import RegistroDDTPage from "@/pages/RegistroDDTPage";
import RegistroCantieriPage from "@/pages/RegistroCantieriPage";
import ImpostazioniPage from "@/pages/ImpostazioniPage";
import GestionalePage from "@/pages/GestionalePage";
import OperaiPage from "@/pages/OperaiPage";
import SchedaOperaioPage from "@/pages/SchedaOperaioPage";
import AnagrafichePage from "@/pages/AnagrafichePage";
import AttrezzaturePage from "@/pages/AttrezzaturePage";
import MagazzinoOriginale from "@/magazzino/MagazzinoOriginale";
import BackupPage from "@/pages/BackupPage";
import ScadenziarioPage from "@/pages/ScadenziarioPage";
import CollaborazioniPage from "@/pages/CollaborazioniPage";
import ContiPage from "@/pages/ContiPage";
import PreventiviPage from "@/pages/PreventiviPage";
import BolleOperaioPage from "@/pages/BolleOperaioPage";
import BolleCantierePage from "@/pages/BolleCantierePage";
import RegistroCaricoPage from "@/pages/RegistroCaricoPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/bolle/:token" element={<BolleOperaioPage />} />
            <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/cantiere/:id" element={<ProtectedRoute><CantiereDetailPage /></ProtectedRoute>} />
            <Route path="/ddt" element={<ProtectedRoute><RegistroDDTPage /></ProtectedRoute>} />
            <Route path="/registro-cantieri" element={<ProtectedRoute><RegistroCantieriPage /></ProtectedRoute>} />
            <Route path="/gestionale" element={<ProtectedRoute><GestionalePage /></ProtectedRoute>} />
            <Route path="/gestionale/ddt" element={<ProtectedRoute><RegistroDDTPage /></ProtectedRoute>} />
            <Route path="/gestionale/registro-cantieri" element={<ProtectedRoute><RegistroCantieriPage /></ProtectedRoute>} />
            <Route path="/gestionale/operai" element={<ProtectedRoute><OperaiPage /></ProtectedRoute>} />
            <Route path="/gestionale/operai/:id" element={<ProtectedRoute><SchedaOperaioPage /></ProtectedRoute>} />
            <Route path="/gestionale/anagrafiche" element={<ProtectedRoute><AnagrafichePage /></ProtectedRoute>} />
            <Route path="/gestionale/attrezzature" element={<ProtectedRoute><AttrezzaturePage /></ProtectedRoute>} />
            <Route path="/gestionale/magazzino/*" element={<ProtectedRoute><MagazzinoOriginale /></ProtectedRoute>} />
            <Route path="/gestionale/magazzino-alluminio/*" element={<ProtectedRoute><MagazzinoOriginale /></ProtectedRoute>} />
            <Route path="/gestionale/backup" element={<ProtectedRoute><BackupPage /></ProtectedRoute>} />
            <Route path="/gestionale/scadenziario" element={<ProtectedRoute><ScadenziarioPage /></ProtectedRoute>} />
            <Route path="/gestionale/collaborazioni" element={<ProtectedRoute><CollaborazioniPage /></ProtectedRoute>} />
            <Route path="/gestionale/conti" element={<ProtectedRoute><ContiPage /></ProtectedRoute>} />
            <Route path="/gestionale/preventivi" element={<ProtectedRoute><PreventiviPage /></ProtectedRoute>} />
            <Route path="/gestionale/bolle-cantiere" element={<ProtectedRoute><BolleCantierePage /></ProtectedRoute>} />
            <Route path="/gestionale/registro-carico" element={<ProtectedRoute><RegistroCaricoPage /></ProtectedRoute>} />
            <Route path="/impostazioni" element={<ProtectedRoute><ImpostazioniPage /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
